import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    entities: {},
    components: {
        extendLabelRule: {
            component: 'Viewport',
        },
    },
    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/product',
                    breadcrumbName: '商品管理',
                    component: 'Viewport',
                    childRoutes: [
                        {
                            path: '/extendLabelRule',
                            component: 'extendLabelRule',
                            breadcrumbName: '扩展标签规则管理',
                            childRoutes: [
                                {
                                    path: '/update/:id',
                                    component: 'extendLabelRuleAddView',
                                    breadcrumbName: '标签规则修改',
                                },
                                {
                                    path: '/detail/:id',
                                    component: 'extendLabelRuleAddView',
                                    breadcrumbName: '标签规则详情',
                                },
                                {
                                    path: '/add',
                                    component: 'extendLabelRuleAddView',
                                    breadcrumbName: '新增标签规则',
                                },
                                {
                                    path: '/',
                                    component: 'extendLabelRuleListView',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
};
